/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomOrderItems = {
  packagingId: string;
  quantity: number;
};

export type CustomOrdersInsert = {
  comment?: string | null | undefined;
  contractId: string;
  deliveryDate?: string | null | undefined;
  items: Array<CustomOrderItems>;
};

export type InsertOrdersActionMutationVariables = Exact<{
  userId: string;
  basketId: string;
  ordersData: Array<Types.CustomOrdersInsert> | Types.CustomOrdersInsert;
  isSuggested?: boolean | null | undefined;
}>;


export type InsertOrdersActionMutation = { insertOrdersAction: Array<{ id: string, friendly_id: string, reference_id: string, supplying_company_name: string, buying_company_name: string, buying_company_brand: string | null, order_price: number, supplierPhotoDomain: string | null, supplierPhotoPath: string | null, buyerPhotoDomain: string | null, buyerPhotoPath: string | null, packagingCount: number, deliveryDate: string | null }> | null };


export const InsertOrdersActionDocument = /*#__PURE__*/ gql`
    mutation InsertOrdersAction($userId: uuid!, $basketId: uuid!, $ordersData: [CustomOrdersInsert!]!, $isSuggested: Boolean) {
  insertOrdersAction(
    basketId: $basketId
    ordersData: $ordersData
    userId: $userId
    isSuggested: $isSuggested
  ) {
    id
    friendly_id
    reference_id
    supplying_company_name
    buying_company_name
    buying_company_brand
    order_price
    supplierPhotoDomain
    supplierPhotoPath
    buyerPhotoDomain
    buyerPhotoPath
    packagingCount
    deliveryDate
  }
}
    `;
export type InsertOrdersActionMutationFn = Apollo.MutationFunction<InsertOrdersActionMutation, InsertOrdersActionMutationVariables>;

/**
 * __useInsertOrdersActionMutation__
 *
 * To run a mutation, you first call `useInsertOrdersActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertOrdersActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertOrdersActionMutation, { data, loading, error }] = useInsertOrdersActionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      basketId: // value for 'basketId'
 *      ordersData: // value for 'ordersData'
 *      isSuggested: // value for 'isSuggested'
 *   },
 * });
 */
export function useInsertOrdersActionMutation(baseOptions?: Apollo.MutationHookOptions<InsertOrdersActionMutation, InsertOrdersActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertOrdersActionMutation, InsertOrdersActionMutationVariables>(InsertOrdersActionDocument, options);
      }
export type InsertOrdersActionMutationHookResult = ReturnType<typeof useInsertOrdersActionMutation>;
export type InsertOrdersActionMutationResult = Apollo.MutationResult<InsertOrdersActionMutation>;
export type InsertOrdersActionMutationOptions = Apollo.BaseMutationOptions<InsertOrdersActionMutation, InsertOrdersActionMutationVariables>;